/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/
/* Sample JavaScript file added with ScriptTag resource.
This sample file is meant to teach best practices.
Your app will load jQuery if it's not defined.
Your app will load jQuery if jQuery is defined but is too old, e.g. < 1.7.
Your app does not change the definition of $ or jQuery outside the app.
Example: if a Shopify theme uses jQuery 1.4.2, both of these statements run in the console will still return '1.4.2'
once the app is installed, even if the app uses jQuery 1.9.1:
jQuery.fn.jquery => "1.4.2"
$.fn.jquery -> "1.4.2"
*/
/* Using a self-executing anonymous function - (function(){})(); - so that all variables and functions defined within
aren’t available to the outside world. */


(function(){
  /* Load Script function we may need to load jQuery from the Google's CDN */
  /* That code is world-reknown. */
  /* One source: http://snipplr.com/view/18756/loadscript/ */

  var loadScript = function(url, callback){
    var script = document.createElement("script");
    script.type = "text/javascript";
    // If the browser is Internet Explorer.
    if (script.readyState){
      script.onreadystatechange = function(){
        if (script.readyState == "loaded" || script.readyState == "complete"){
          script.onreadystatechange = null;
          callback();
        }
      };
    // For any other browser.
    } else {
      script.onload = function(){
        callback();
      };
    }
    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);
  };

  // product quickview on collection page
  function onVariantSelect(container, productId, selector){
    var productSelector = '#ProductSelect-'+productId,
      optionsLength = $(selector).length;
      $(selector).prop("selectedIndex", 0); // sets the first option of option dropdowns selected
      $(selector).on('change', function() {
        onVariantChange(optionsLength, productId, productSelector, container);
      });

      // size swatches when clicked
      $(container+' .swatch-size .swatch-element').on('click', function() {
        var selectedValue = $(this).data('value');
        $(container+' .selector-wrapper-size .single-option-selector').val(selectedValue).trigger('change');
        onVariantChange(optionsLength, productId, productSelector, container);
      });

      // color or material swatches when clicked
      $(container+' .swatch-color .swatch-element').on('click', function() {
        var selectedValue = $(this).data('value');
        if($(container+' .selector-wrapper-color').length) {
          $(container+' .selector-wrapper-color .single-option-selector').val(selectedValue).trigger('change');
        }
        if($(container+' .selector-wrapper-material').length) {
          $(container+' .selector-wrapper-material .single-option-selector').val(selectedValue).trigger('change');
        }
        onVariantChange(optionsLength, productId, productSelector, container);
      });
    
      var formSelector = $('#qw-form-'+ productId);
      formSelector.find('.single-option-selector').trigger("change");
      formSelector.find('.swatch_container').removeClass('swatch_indicator');
      formSelector.find('.swatch-element').removeClass('swatch_indicator');
  }

  // product quickview on collection page -- on variant select from dropdown
  function onVariantChange(optionsLength, productId, productSelector, container){
    var selectedValue="", selectedVariant="";
    //get selected value from each dropdown options
    for (ctr=0; ctr<optionsLength; ctr++) {
      selectedValue = selectedValue + $('#SingleOptionSelector-'+ productId +'-'+ctr).val();
      if(ctr < optionsLength-1) {
        selectedValue = selectedValue+"-";
      }
    }
    selectedVariant =  $.trim(selectedValue.toLowerCase().replace(/\W+/g,'-'));
    var selectedVariantPrice;
    if (selectedVariant != "" || selectedVariant != null ) {

      if($(productSelector+' option[data-title='+ selectedVariant +']').length){
        /*
          Update variant image
        */
        var qvMainImg = $(container+' .quickview-image-wrapper');
        var varImg = $(productSelector+' option[data-title='+ selectedVariant +']').data('image');
        qvMainImg.html('<img data-src="'+ varImg +'" class="quickview-image Image--lazyLoad Image--fadeIn Image--lazyLoading" alt="" width="488" height="604"><span class="Image__Loader"></span>');
        /*
          if selected variant is sold out or not available
        */
        if($(productSelector+' option[data-title='+ selectedVariant +']').is(':disabled')) {
          $(productSelector+' option[data-title='+ selectedVariant +']').prop('selected', true);
          $('#AddToCartText-'+productId).text('Sold Out');
          $('#AddToCart-'+productId).prop('disabled', true);
          $(productSelector).find('option:selected').prop('selected', false);

          if($(container+' .regular-price').is(':visible')) {
              $(container+' .regular-price').remove();
          }
          selectedVariantPrice = $(productSelector+' option[data-title='+ selectedVariant +']').data('price');
          $(container+' .product-single__price .price').text(selectedVariantPrice);
        }
    /*
          if selected variant is available
          set main dropdown (with name="id") to its selected variant,
          enable add to cart button and update price to the price of the selected variant
        */
        else {
          $(productSelector).find('option:selected').prop('selected', false);
          $(productSelector+' option[data-title='+ selectedVariant +']').prop('selected', true);
          $('#AddToCart-'+productId).prop('disabled', false);
          $('#AddToCartText-'+productId).text('Add to cart');

          selectedVariantPrice = $(productSelector+' option[data-title='+ selectedVariant +']').data('price');
          if($(productSelector+' option[data-title='+ selectedVariant +']').hasClass('sale')){
            $(container+' .product-single__price .price').html('<span class="sale-text Price--highlight">Now</span> '+ selectedVariantPrice);
            $(container+' .regular-price').remove();
            var selectedRegularPrice = $(productSelector+' option[data-title='+ selectedVariant +']').data('regularprice');
            $(container+' .product-single__price').prepend('<s class="regular-price">'+ selectedRegularPrice+'</s>');
            $(container+' .product-single__price .price').addClass('Price--highlight');
          }
          else {
            $(container+' .product-single__price .price').text(selectedVariantPrice);
            if($(container+' .regular-price').is(':visible')) {
              $(container+' .regular-price').remove();
            }
            $(container+' .product-single__price .price').removeClass('Price--highlight');
          }
        }

      }
  /*
        if selected variant is not available
        disable add to cart button and update text
      */
      else {
        $(productSelector+' option[data-title='+ selectedVariant +']').prop('selected', true);
        $('#AddToCartText-'+productId).text('Unavailable');
        $('#AddToCart-'+productId).prop('disabled', true);
        $(productSelector).find('option:selected').prop('selected', false);
      }
    }
    else {
      $('#AddToCartText-'+productId).text('Unavailable');
      $('#AddToCart-'+productId).prop('disabled', true);
      $(productSelector).find('option:selected').prop('selected', false);
    }

  }


  // Product quick view on Collection page
  var product_quickview = function() {
    $(".quick_view").fancybox({
      margin: 0,
      animationEffect: "fade",
      transitionEffect: "slide",
      transitionDuration: 500,
      buttons:['close'],
      afterShow: function(instance, current) {
        var productId = $(current.src).attr('data-product-id'); // id of the product quickview container
        var selector = current.src+' .single-option-selector'; // get the option selectors(dropdown) of current active product quickview 
        onVariantSelect(current.src, productId, selector);
        return false;
      }
    });
  };

  if ((typeof jQuery === 'undefined') || (parseFloat(jQuery.fn.jquery) < 1.7)) {
    loadScript('//ajax.googleapis.com/ajax/libs/jquery/2.2.3/jquery.min.js', function(){
        jQuery223 = jQuery.noConflict(true);
        
        if(jQuery223('body').hasClass('template-collection') || jQuery223('body').hasClass('template-product')) {
          product_quickview(jQuery223);
        }
    });
  }
  else {
    // myAppJavaScript(jQuery);
    if(jQuery('body').hasClass('template-collection') || $('body').hasClass('template-product')) {
        product_quickview(jQuery);
    }
  }

})()
